import React from "react";
import RenderChecks from "../../components/RenderChecks";

const GPMChecklist = ({ data }) => <RenderChecks data={data} />;

export default GPMChecklist;
